<template lang="pug">
.start-stop-track
  .start-stop-marker.start-stop-marker-start(
    :style="{ left: startPosition }"
    :class="{ 'start-stop-marker-flipped': isStartFlipped }"
  )
    span.start-stop-marker-time {{ formattedStartTime }}
    IconTimeMarkerStart
  .start-stop-marker.start-stop-marker-end(
    :style="{ left: stopPosition }"
    :class="{ 'start-stop-marker-flipped': isStopFlipped }"
  )
    IconTimeMarkerEnd
    span.start-stop-marker-time {{ formattedStopTime }}
</template>

<script>
import formatMinutesAsTime from '~/components/insights/utils/formatMinutesAsTime';
import IconTimeMarkerStart from '~/components/insights/icons/IconTimeMarkerStart.vue';
import IconTimeMarkerEnd from '~/components/insights/icons/IconTimeMarkerEnd.vue';

export default {
  name: 'InsightsStartStopTimeTrack',
  components: {
    IconTimeMarkerStart,
    IconTimeMarkerEnd,
  },
  props: {
    startTime: {
      type: Number,
      default: null,
    },
    stopTime: {
      type: Number,
      default: null,
    },
    scaleStart: {
      type: Number,
      required: true,
    },
    scaleEnd: {
      type: Number,
      required: true,
    },
    scaleLabelCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    scaleRange() {
      return this.scaleEnd - this.scaleStart;
    },
    formattedStartTime() {
      return formatMinutesAsTime(this.startTime);
    },
    formattedStopTime() {
      return formatMinutesAsTime(this.stopTime);
    },
    startPosition() {
      return this.getPosition(this.startTime);
    },
    stopPosition() {
      return this.getPosition(this.stopTime);
    },
    isStartFlipped() {
      return this.isMarkerFlipped(this.startTime, 0.15);
    },
    isStopFlipped() {
      return this.isMarkerFlipped(this.stopTime, 0.85);
    },
  },
  methods: {
    isMarkerFlipped(minutes, threshold) {
      if (minutes == null || this.scaleRange <= 0) {
        return false;
      }
      const ratio = (minutes - this.scaleStart) / this.scaleRange;

      // For start markers (threshold=0.15): flip when in the first 15% so the
      // label renders to the right instead of overflowing left.
      // For end markers (threshold=0.85): flip when in the last 15% so the
      // label renders to the left instead of overflowing right.
      return threshold < 0.5 ? ratio < threshold : ratio > threshold;
    },
    getPosition(minutes) {
      if (minutes == null) {
        return '0%';
      }
      const labelCount = this.scaleLabelCount;

      if (labelCount < 2) {
        return '0%';
      }

      // Scale labels are centered in grid cells
      // First label center is at 0.5/labelCount, last at (labelCount-0.5)/labelCount
      const firstLabelPos = 0.5 / labelCount;
      const lastLabelPos = (labelCount - 0.5) / labelCount;
      const scaleSpan = lastLabelPos - firstLabelPos;

      // Map minutes to position within the scale span
      const ratio = (minutes - this.scaleStart) / this.scaleRange;
      const percent = (firstLabelPos + ratio * scaleSpan) * 100;

      return `${Math.max(0, Math.min(100, percent))}%`;
    },
  },
};
</script>
